// src/FontawesomeIcon/index.tsx
import React from "react";
var viewBoxMapping = {
  "angle-down:regular": "0 0 448 512",
  "angle-left:regular": "0 0 320 512",
  "angle-right:regular": "0 0 320 512",
  "arrow-up-right:regular": "0 0 384 512",
  "at:regular": "0 0 512 512",
  "calendar-day:regular": "0 0 448 512",
  "calendar:regular": "0 0 448 512",
  "check:regular": "0 0 448 512",
  "chevron-down:regular": "0 0 512 512",
  "chevron-left:regular": "0 0 320 512",
  "chevron-right:regular": "0 0 320 512",
  "chevron-up:regular": "0 0 512 512",
  "circle-check:regular": "0 0 512 512",
  "circle-exclamation:regular": "0 0 512 512",
  "circle-info:regular": "0 0 512 512",
  "circle-minus:solid": "0 0 512 512",
  "circle-plus:regular": "0 0 512 512",
  "circle-plus:solid": "0 0 512 512",
  "circle-xmark:regular": "0 0 512 512",
  "circle:solid": "0 0 512 512",
  "clock:regular": "0 0 512 512",
  "envelope:regular": "0 0 512 512",
  "eye-slash:regular": "0 0 640 512",
  "eye-slash:solid": "0 0 640 512",
  "eye:regular": "0 0 576 512",
  "eye:solid": "0 0 576 512",
  "house-medical:regular": "0 0 576 512",
  "location-dot:regular": "0 0 384 512",
  "magnifying-glass:regular": "0 0 512 512",
  "messages:regular": "0 0 640 512",
  "minus:regular": "0 0 448 512",
  "pen:regular": "0 0 512 512",
  "pen:solid": "0 0 512 512",
  "plus:regular": "0 0 448 512",
  "spinner-third:duotone": "0 0 512 512",
  "star:regular": "0 0 576 512",
  "triangle-exclamation:regular": "0 0 512 512",
  "user-vneck:regular": "0 0 448 512",
  "xmark:regular": "0 0 384 512"
};
function FontAwesomeIcon({ name, ...rest }) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "currentColor", viewBox: viewBoxMapping[name], ...rest }, /* @__PURE__ */ React.createElement(
    "use",
    {
      xlinkHref: `${typeof KIIWI_FONTAWESOME_ICON_SPRITE_PATH !== "undefined" ? KIIWI_FONTAWESOME_ICON_SPRITE_PATH : "/fontawesome-sprites.svg"}?hash=3c7ece001e401f2498676b9215797560b29afb1a440de2d96aa7f3dc7768ea5f#${name}`
    }
  ));
}

export {
  FontAwesomeIcon
};
//# sourceMappingURL=chunk-APS5QAFW.js.map